module.exports = __webpack_public_path__ + "static/img/bg.d15b58c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/bg.png
// module id = NLbk
// module chunks = 0